import { en } from "@/translations/en";
import { fr } from "@/translations/fr";

export type TranslationKey = keyof typeof en;
export type NestedTranslationKeys<T> = {
  [K in keyof T]: T[K] extends object
    ? `${string & K}.${string & keyof T[K]}`
    : K;
}[keyof T];

export type TranslationString = NestedTranslationKeys<typeof en>;

const translations = {
  english: en,
  french: fr,
};

export type Language = keyof typeof translations;

export const getTranslation = (
  language: Language,
  key: TranslationString
): string => {
  const keys = key.split(".");
  let current: any = translations[language];

  for (const k of keys) {
    if (current[k] === undefined) {
      console.warn(`Translation missing for key: ${key} in ${language}`);
      return key;
    }
    current = current[k];
  }

  return current;
};

export const useTranslation = (language: Language) => {
  return (key: TranslationString) => getTranslation(language, key);
};
